import { useState, createContext, useContext } from 'react'

interface Context<T = any> {
  selection: Array<T>
  addSelection: (item: T, clear?: boolean) => void,
  addMultipleSelection: (items: T[]) => void,
  clearSelection: () => void,
}

const DEFAULTCONTEXT: Context = {
  selection: [],
  addSelection: () => { },
  addMultipleSelection: () => { },
  clearSelection: () => { },
};

const useSelection = (): Context => {
  const [selection, setSelection] = useState<Array<any>>([])

  function addSelection(item: any, clear = true) {
    if (-1 === selection.indexOf(item)) {
      setSelection(clear ? [item] : [...selection, item])
    } else {
      setSelection(o => {
        o.splice(o.indexOf(item), 1)
        return [...o];
      })
    }
  }

  function addMultipleSelection(items: any[]) {
    console.warn('addMultipleSelection not done yet');
    // setSelection(items)
  }

  const clearSelection = () => {
    setSelection([])
  }

  return { selection, addSelection, addMultipleSelection, clearSelection }
}

const MultiSelectionContext = createContext<Context>(DEFAULTCONTEXT)

export const useMultiSelectionContext = () => useContext(MultiSelectionContext);

interface MultiSelectionProviderProps {
  children: React.ReactChild | React.ReactChildren
}

function MultiSelectionProvider({ children, ...rest }: MultiSelectionProviderProps) {
  const { selection, addSelection, addMultipleSelection, clearSelection } = useSelection();
  return (
    <MultiSelectionContext.Provider value={{ selection, addSelection, addMultipleSelection, clearSelection, }}>
      {children}
    </MultiSelectionContext.Provider>
  );
}

export default MultiSelectionProvider
